import { createEndpoints } from '../../_helpers/utile/endpoint.helper';

export const SOPRA_ENDPOINTS = {
  V2: createEndpoints('v2', {
    CLASSIFICATIONS: '/classifications/',
    CLASSIFICATION: (id: number) => `/classifications/${id}/`,
    SOPRA_SERVICES_REQUEST: '/admin/classifications/applications/',
    SOPRA_SERVICE_DETAILS: (id: number) => `/admin/classifications/applications/${id}/`,
  }),
} as const;
